export default __webpack_public_path__ + "static/media/logoIn.95504855.png";